module.exports = __webpack_public_path__ + "static/victory-a0438b145e7e9611fc350e79cda57b40.jpg";